import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleActivityType = {
  namespaced: true,

  state: {
    name: 'activity-type',
    nextSeqCode: null,
    activityTypes: []
  },

  mutations,
  getters,
  actions
}

export default moduleActivityType;